export const IMAGE_SIZES = {
  THUMBNAIL: '50x50',
  SMALL: '200x200',
  MEDIUM: '300x300',
  LARGE: '600x600',
  
  MOBILE: '400xauto',
  TABLET: '600xauto',
  DESKTOP: '800xauto',
  HERO: '1200xauto',
  
  FULLHD: '1920xauto',
  RETINA: '1440xauto',
  UHD: '3840xauto',
  
  CART_ITEM: 'cart-item',
  ORIGINAL: 'orig_',
  
  VERTICAL_FULLHD: 'autox1920',
  VERTICAL_RETINA: 'autox1440',
  VERTICAL_UHD: 'autox3840',
} as const

// Типы для TypeScript
export type ImageSize = typeof IMAGE_SIZES[keyof typeof IMAGE_SIZES];